export var Formats;
(function (Formats) {
    Formats["deep dive"] = "deep dive";
    Formats["video"] = "video";
    Formats["tutorial"] = "tutorial";
})(Formats || (Formats = {}));
